import { 
    SET_CARRIER_QUEUES_SCHEDULE
} from '../actionTypes'

const initialState = {}

export default (state=initialState,  action) => {
    switch(action.type) {
        case SET_CARRIER_QUEUES_SCHEDULE:
            return action.schedule
        default:
            return state
    }
}
